import React from "react"
import Section from "../../../../core/layout/main/section/Section"
import * as classNames from "./TitleVideo.module.scss"
import ImageVideo from "../../../../core/image-video/ImageVideo"
function TitleVideoSection({ title, baseline, imageVideoData }) {
  return (
    <Section
      classNames={"pbl-12"}
      container={"xlarge"}
    >
      <div className={`${classNames.content} text-center pin-6`}>
        <h1>{title}</h1>
        <p>{baseline}</p>
      </div>
      <ImageVideo imageVideoData={imageVideoData} />
    </Section>
  )
}
export default TitleVideoSection
